import { render, staticRenderFns } from "./CongTyLuHanhForm.vue?vue&type=template&id=05990d30&"
import script from "./CongTyLuHanhForm.vue?vue&type=script&lang=js&"
export * from "./CongTyLuHanhForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports